import type { FeatureAccessStatus } from 'v2/interfaces/featureAccess';

export type AnticipationData = {
  credit_days: number;
  has_promotional_fee: boolean;
  custom_fee: {
    value: number;
  };
  anticipation_fees: {
    fixed_automatic_fee: number;
    dynamic_automatic_fee: number;
    fixed_manual_fee: number;
    dynamic_manual_fee: number;
  };
};

export type Props = {
  anticipationAccessData: FeatureAccessStatus;
  modalAnticipateIsOpen: boolean;
  handleSetHasValueToAnticipate: (hasValueToAnticipate: boolean) => void;
  updateTransferAvailable: () => void;
  handleToggleTransferModal: () => void;
  handleToggleAnticipateModal: () => void;
};

export const NO_PAID_INVOICE_MORE_THIRTY_DAYS_ERROR = 'INV01';
export const HIGH_CHARGEBACK_ERROR = 'CGB01';
